import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n/config";
// Self-hosted variable fonts (no external Google Fonts round-trip → faster LCP,
// no render-blocking css2 request, stable CLS). One compact woff2 per family.
import "@fontsource-variable/space-grotesk/wght.css";
import "@fontsource-variable/dm-sans/wght.css";
import "@fontsource-variable/dm-sans/wght-italic.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import "./index.css";
import { maybeHandleRedirect } from "./lib/redirect.ts";

// An inline script in index.html resolves marketing short links (/wa-1) before
// this bundle even loads, exposing the result on window.__DC_REDIRECT__. Await
// it so we never re-resolve (which would double-count the click) and never boot
// the SPA on top of an in-flight redirect. Fall back to the module resolver if
// the early script didn't run (e.g. in dev/test environments).
const early = (window as unknown as {
  __DC_REDIRECT__?: Promise<boolean>;
}).__DC_REDIRECT__;

void (early ?? maybeHandleRedirect()).then((redirected) => {
  if (redirected) return;
  createRoot(document.getElementById("root")!).render(<App />);
});
